/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */

import Vue from 'vue';
import '@sal/inview-plugin';
import Responsive from '@sal/layout';
import vueCustomElement from 'vue-custom-element';

Vue.use(vueCustomElement);

window.Vue = Vue;

Vue.use(Responsive);

const options = {
	props: ['securityId', 'securityType', 'contentType', 'maasToken']
};

Vue.customElement(
	'sal-components-funds-quote',
	() => new Promise(resolve => {
		require(['./components/funds/quote.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-funds-analysis',
	() => new Promise(resolve => {
		require(['./components/funds/analysis.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-funds-parent',
	() => new Promise(resolve => {
		require(['./components/funds/parent.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-funds-portfolio',
	() => new Promise(resolve => {
		require(['./components/funds/portfolio.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-funds-performance',
	() => new Promise(resolve => {
		require(['./components/funds/performance.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-funds-price',
	() => new Promise(resolve => {
		require(['./components/funds/price.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-funds-risk',
	() => new Promise(resolve => {
		require(['./components/funds/risk.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-funds-sustainability',
	() => new Promise(resolve => {
		require(['./components/funds/sustainability.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-funds-people',
	() => new Promise(resolve => {
		require(['./components/funds/people.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-funds-chart',
	() => new Promise(resolve => {
		require(['./components/funds/chart.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-funds-strategy',
	() => new Promise(resolve => {
		require(['./components/funds/strategy.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cefs-analysis',
	() => new Promise(resolve => {
		require(['./components/cefs/analysis.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cefs-ownership',
	() => new Promise(resolve => {
		require(['./components/cefs/ownership.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cefs-people',
	() => new Promise(resolve => {
		require(['./components/cefs/people.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cefs-portfolio',
	() => new Promise(resolve => {
		require(['./components/cefs/portfolio.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cefs-price',
	() => new Promise(resolve => {
		require(['./components/cefs/price.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cefs-quote',
	() => new Promise(resolve => {
		require(['./components/cefs/quote.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cefs-risk',
	() => new Promise(resolve => {
		require(['./components/cefs/risk.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cefs-strategy',
	() => new Promise(resolve => {
		require(['./components/cefs/strategy.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cefs-sustainability',
	() => new Promise(resolve => {
		require(['./components/cefs/sustainability.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cefs-performance',
	() => new Promise(resolve => {
		require(['./components/cefs/performance.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cefs-chart',
	() => new Promise(resolve => {
		require(['./components/cefs/chart.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-indexes-performance',
	() => new Promise(resolve => {
		require(['./components/indexes/performance.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-indexes-portfolio',
	() => new Promise(resolve => {
		require(['./components/indexes/portfolio.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-indexes-quote',
	() => new Promise(resolve => {
		require(['./components/indexes/quote.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-indexes-risk',
	() => new Promise(resolve => {
		require(['./components/indexes/risk.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stocks-dividends',
	() => new Promise(resolve => {
		require(['./components/stocks/dividends.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stocks-executive',
	() => new Promise(resolve => {
		require(['./components/stocks/executive.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stocks-financials',
	() => new Promise(resolve => {
		require(['./components/stocks/financials.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stocks-ownership',
	() => new Promise(resolve => {
		require(['./components/stocks/ownership.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stocks-performance',
	() => new Promise(resolve => {
		require(['./components/stocks/performance.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stocks-price-vs-fair-value',
	() => new Promise(resolve => {
		require(['./components/stocks/price.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stocks-sustainability',
	() => new Promise(resolve => {
		require(['./components/stocks/sustainability.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stocks-trailing-returns',
	() => new Promise(resolve => {
		require(['./components/stocks/trailing-returns.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stocks-valuation',
	() => new Promise(resolve => {
		require(['./components/stocks/valuation.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stocks-chart',
	() => new Promise(resolve => {
		require(['./components/stocks/chart.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-global-market-barometer',
	() => new Promise(resolve => {
		require(['./components/global-market-barometer.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-plan-center',
	() => new Promise(resolve => {
		require(['./components/plan-center.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-plan-info',
	() => new Promise(resolve => {
		require(['./components/plan-info.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-etfs-chart',
	() => new Promise(resolve => {
		require(['./components/etfs/chart.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-etfs-people',
	() => new Promise(resolve => {
		require(['./components/etfs/people.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-etfs-quote',
	() => new Promise(resolve => {
		require(['./components/etfs/quote.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-etfs-strategy',
	() => new Promise(resolve => {
		require(['./components/etfs/strategy.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);
